
export default function TableSkeleton() {
  return (
    <div className="space-y-6">
      {/* Filter and Columns Skeleton */}
      {/* <div className="flex justify-between items-center space-x-6">
        <div className="flex gap-6">
          <div className="w-72 h-10 bg-gray-200 animate-pulse rounded-lg"></div>
          <div className="w-36 h-10 bg-gray-200 animate-pulse rounded-lg"></div>
        </div>
        <div className="w-32 h-10 bg-gray-200 animate-pulse rounded-md"></div>
      </div> */}

      {/* New Exam Button Skeleton */}

      {/* Table Skeleton */}
      <div className="space-y-2">
        {/* Table Header Skeleton */}
        <div className="flex justify-between bg-gray-100 p-4 rounded-md">
          <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
          <div className="w-32 h-6 bg-gray-200 animate-pulse rounded"></div>
          <div className="w-32 h-6 bg-gray-200 animate-pulse rounded"></div>
          <div className="w-28 h-6 bg-gray-200 animate-pulse rounded"></div>
          <div className="w-24 h-6 bg-gray-200 animate-pulse rounded"></div>
        </div>

        {/* Table Row Skeleton (Repeat for each row) */}
        {Array.from({ length: 10 }).map((_, index) => (
          <div key={index} className="flex justify-between p-2 rounded-md space-x-4 bg-white shadow-md mt-2">
            <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
            <div className="w-32 h-6 bg-gray-200 animate-pulse rounded"></div>
            <div className="w-32 h-6 bg-gray-200 animate-pulse rounded"></div>
            <div className="w-28 h-6 bg-gray-200 animate-pulse rounded"></div>
            <div className="w-24 h-6 bg-gray-200 animate-pulse rounded"></div>
          </div>
        ))}
      </div>
    </div>
  );
};
